import { render } from "./Demo.vue?vue&type=template&id=140c12e6&scoped=true"
import script from "./Demo.vue?vue&type=script&lang=js"
export * from "./Demo.vue?vue&type=script&lang=js"

import "./Demo.vue?vue&type=style&index=0&id=140c12e6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/veins_practice_vue/veins_practice_vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-140c12e6"]])

export default __exports__